import React, { Fragment, memo, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Provider
import { AppContext } from "../../../components/AppProvider";

// Utils

// UI
import { Doctor, IC } from "../../../resources/Assets";
import {
  AlertPopup,
  Container,
  DateLayer,
  EveryDayTimeLayer,
  MonthDateLayer,
  WeekTimeLayer,
  closeLayerFn,
  openLayerFn,
} from "../../Layout";
import { SUBS, SubMenu } from "./History";

import { addDays, addMonths, format } from "date-fns";

import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import SettingComponent from "./Medicine.Settings";
import Contents from "./Medicine/Component/Contents";
// POST
import { ConfirmLayer } from "../../../components/UI/Dialog";
import MemoList from "../../../components/UI/MemoPopup/MemoList";
import useTitle from "../../../modules/hooks/useTitle";
import {
  PostApi1110,
  PostApi1111,
  PostApi1112,
  PostApi1115,
  PostApi1116,
  PostApi1117,
  PostApi1118,
} from "../../../modules/network/padoPost";
import { NativeAction } from "../../../modules/utils/HandleWs";
import {
  PeriodTypeChange,
  convertFormat,
} from "../../../modules/utils/PeriodTypeChange";
import { userHabit } from "../../../modules/utils/UserHabit";
const interfaceDateFormat = "yyyyMMdd";

export default props => {
  useTitle("자가건강관리_혈당_복약이력");
  const sub = SUBS[3];

  const [list, setList] = useState([{}]);

  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const [resData, setResData] = useState("");
  const [takeHist, setTakeHist] = useState("");
  const [periodType, setPeriodType] = useState(1);
  const [reqStartDate, setReqStartDate] = useState(
    convertFormat(PeriodTypeChange("year", 1), "yyyyMMdd")
  );
  const [reqEndDate, setReqEndDate] = useState(
    convertFormat(PeriodTypeChange("year", 0), "yyyyMMdd")
  );

  const [pageNo, setPageNo] = useState(1);
  const [pageCnt, setPageCnt] = useState(500);

  const handleDate = (isStart, date) => {
    if (isStart === "1") {
      setReqStartDate(date);
    } else {
      setReqEndDate(date);
    }
    loadData();
  };

  const settingPerionType = periodType => {
    setPeriodType(periodType);
  };

  const request1115 = (periodType, searchFromDt, searchToDt, mdcnType) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      default:
        reqStartDate = searchFromDt;
        reqEndDate = searchToDt;
        break;
    }

    if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
      PostApi1115(
        userinfo,
        cfg,
        phonecfg,
        periodType,
        reqStartDate,
        reqEndDate,
        mdcnType
      )
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            setResData(res.result);
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const request1116 = (
    periodType,
    searchFromDt,
    searchToDt,
    mdcnType,
    pageNo,
    pageCnt
  ) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      default:
        reqStartDate = searchFromDt;
        reqEndDate = searchToDt;
        break;
    }

    if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
      PostApi1116(
        userinfo,
        cfg,
        phonecfg,
        periodType,
        reqStartDate,
        reqEndDate,
        mdcnType,
        pageNo,
        pageCnt
      )
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            setTakeHist(res.result);
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      if (reqStartDate != "" && reqEndDate != "" && reqStartDate > reqEndDate) {
        alert("선택한 날짜를 확인하세요.");
      }
    }
  };

  const loadData = () => {
    if (periodType === 4) {
      if ($(".pick-num1").val() != "" && $(".pick-num2").val() != "") {
        request1115(periodType, reqStartDate, reqEndDate, "BS");
        request1116(
          periodType,
          reqStartDate,
          reqEndDate,
          "BS",
          pageNo,
          pageCnt
        );
      } else {
        // setTotalCnt("0");
        setResData({ totalCnt: "0" });
      }
    } else {
      request1115(periodType, reqStartDate, reqEndDate, "BS");
      request1116(periodType, reqStartDate, reqEndDate, "BS", pageNo, pageCnt);
    }
  };

  useEffect(() => {
    loadData();
  }, [periodType, reqStartDate, reqEndDate]);

  return (
    <Fragment>
      <Container
        Title={sub.label}
        bottom={list.length === 0 ? <Bottom /> : null}
        goToUrl="/sm"
        color="green">
        <div className="contents sub">
          <SubMenu code={sub.code} />
          <div className="sub-contents">
            <div className="date-setting-area">
              <div className="btns">
                <a
                  onClick={() => settingPerionType(1)}
                  className={periodType == 1 ? "on" : ""}>
                  1주일
                </a>
                <a
                  onClick={() => settingPerionType(2)}
                  className={periodType == 2 ? "on" : ""}>
                  1개월
                </a>
                <a
                  onClick={() => settingPerionType(3)}
                  className={periodType == 3 ? "on" : ""}>
                  3개월
                </a>
                <a
                  onClick={() => settingPerionType(4)}
                  // className={
                  //   periodType == 4 ? "btn-selfinput on" : "btn-selfinput"
                  // }
                  className={`btn-selfinput ${periodType == 4 ? "on" : ""}`}>
                  {" "}
                  기간설정
                </a>
              </div>
              <div
                className="date-input"
                style={
                  periodType === 4 ? { display: "block" } : { display: "none" }
                }>
                <div className="round-bar">
                  <div className="ipbox">
                    <input
                      type="text"
                      placeholder="선택하세요."
                      readOnly
                      className="date-picker-input pick-num1"
                      data-num="1"
                    />
                    <i></i>
                  </div>
                  <u>~</u>
                  <div className="ipbox">
                    <input
                      type="text"
                      placeholder="선택하세요."
                      readOnly
                      className="date-picker-input pick-num2"
                      data-num="2"
                    />
                    <i></i>
                  </div>
                </div>
              </div>
            </div>

            {resData && resData.totalCnt && resData.totalCnt === "0" ? (
              <Nothing />
            ) : resData && resData.totalCnt && resData.totalCnt !== "0" ? (
              <History
                settingPerionType={settingPerionType}
                resData={resData}
                takeHist={takeHist}
              />
            ) : null}
          </div>
        </div>
      </Container>
      <DateLayer handleDate={handleDate} color="green" />
    </Fragment>
  );
};

const MdcnBottom = props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const { request1118, resetForm } = props;

  const request1111 = mdcnType => {
    PostApi1111(userinfo, cfg, phonecfg, mdcnType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          request1118("BS");
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const updateAlrm = () => {
    request1111("BS");
    resetForm();
  };
  // 알람 업데이트 끝

  return (
    <div
      className="under-fix-btnarea"
      id="resetForm"
      style={{ display: "none" }}>
      <a className="btn-half-box uncke" onClick={resetForm}>
        <i></i>취소
      </a>
      <a className="btn-half-box ok" onClick={updateAlrm}>
        <i></i>저장
      </a>
    </div>
  );
};

export const Input = props => {
  useTitle("자가건강관리_혈당_복약입력");
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  let toDay = new Date();

  let year = toDay.getFullYear();
  let month = toDay.getMonth() + 1;
  let date = toDay.getDate();

  let nowDate = year + "-" + month + "-" + date;

  const sub = SUBS[1];
  const [settings, setSettings] = useState("SETTING");
  // const [mod, setMod] = useState("EMPTY");
  const [mod, setMod] = useState(null);
  const [mdcnMemo, setMdcnMemo] = useState("");
  const [mdcnDate, setMdcnDate] = useState(nowDate);
  const [mdcnId, setMdcnId] = useState();

  const [alrmList, setAlrmList] = useState();
  const [alrmTypeCd, setAlrmTypeCd] = useState();

  const [totalCnt, setTotalCnt] = useState(0);

  const handleDate = (mdcnCyclCd, mdcnCyclVal, mdcnCyclDtlCd, mdcnTime) => {
    let mode = $("#mode").val();

    $("#mdcnCyclCd").val(mdcnCyclCd);
    $("#mdcnCyclVal").val(mdcnCyclVal);
    $("#mdcnCyclDtlCd").val(mdcnCyclDtlCd);
    $("#mdcnTime").val(mdcnTime);

    if (mode === "ADD") {
      // 데이터 입력
      request1110("BS");
    }
  };

  const request1110 = mdcnType => {
    PostApi1110(userinfo, cfg, phonecfg, mdcnType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          request1118("BS");
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const resetForm = () => {
    $("input[name=mdcnNameInput]").val("");

    // 알람 주기 설정 초기화
    $(".btn-day-set-layer").removeClass("on");
    $(".btn-week-set-layer").removeClass("on");
    $(".btn-month-set-layer").removeClass("on");

    // 데이터 초기화
    $("#mode").val("ADD");
    $("input[name=mdcnNameInput]").val("");
    $("#alrmTypeCd").val("");
    $("#mdcnCyclCd").val("");
    $("#mdcnCyclVal").val("");
    $("#mdcnCyclDtlCd").val("");
    $("#mdcnTime").val("");
    $("#mdcnId").val("");

    // 알람 설정 초기화
    $(".select-custom-box")
      .find("a.btn-select")
      .html("알림 방법을 선택하세요.");
    $(".select-gray-enable a.btn-select").addClass("gray");

    // 확인버튼 숨기기
    $("#resetForm").hide();
  };

  const updateModState = param => {
    if (param === "VIEW") {
      $("#modStatus").addClass("off");
      setMod("MOD");
      userHabit(phonecfg, "BS122");
    } else {
      if (totalCnt > 0) {
        setMod("VIEW");
        $("#modStatus").removeClass("off");
      } else {
        setMod("EMPTY");
      }
      userHabit(phonecfg, "BS121");
    }
  };

  const request1118 = mdcnType => {
    PostApi1118(userinfo, cfg, phonecfg, mdcnType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setTotalCnt(res.result.length);
          setAlrmList(res.result);
          resetForm();

          if (res.result.length !== 0) {
            setMod("VIEW");
          } else {
            setMod("EMPTY");
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    //확인 버튼 //열기
    $(".btn-saveconfirm").click(function () {
      openLayerFn($(".save-question-layer"));

      setMdcnMemo($(".textarea-box").val());
    });
    //닫기
    $(".save-question-layer .tbns-area a").click(function () {
      closeLayerFn($(".save-question-layer"));
    });
  }, [mod]);

  useEffect(() => {
    request1118("BS");
  }, []);

  const request1112 = (mdcnId, mdcnType) => {
    PostApi1112(userinfo, cfg, phonecfg, mdcnId, mdcnType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          request1118("BS");
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleConfirmConfirmCB = () => {
    request1112(mdcnId, "BS");
  };
  const handleConfirmCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  useEffect(() => {
    userHabit(phonecfg, "BS121");
    NativeAction(phonecfg, "statusColor", "#7FD2C2");
  }, [phonecfg.version]);

  if (mod === "EMPTY") {
    const bottom = (
      <div className="under-fix-btnarea">
        <a
          href={void 0}
          className="btn-setting"
          onClick={e => updateModState("VIEW")}>
          <i></i>설정
        </a>
      </div>
    );
    return (
      <Fragment>
        <ScrollToTop />
        <Container
          Title={sub.label}
          bottom={bottom}
          goToUrl="/sm"
          color="green">
          <div className="contents sub">
            <SubMenu code={sub.code} />
            <div className="sub-contents">
              <div className="nothing-box">
                <div>
                  <img src={IC.empty.medicine} alt="" />
                  <p>
                    복약설정 정보가 없습니다.
                    <br />
                    복약설정을 해주세요.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <ScrollToTop />
        <Container
          Title={sub.label}
          bottom={
            <MdcnBottom request1118={request1118} resetForm={resetForm} />
          }
          goToUrl="/sm"
          color="green">
          <div className="contents sub">
            <SubMenu code={sub.code} />

            <div className="sub-contents nmg">
              <div className="section-box">
                <div className="sub-title">
                  복약정보
                  <div className="tog-cmm-left">복약설정</div>
                  <div className="toggle-cmm">
                    <a
                      id="modStatus"
                      className={mod === "MOD" ? "off" : ""}
                      onClick={e => updateModState(mod)}>
                      완료<i></i>수정
                    </a>
                  </div>
                  {/* 완료 or 수정 토글시 비동기로 하단 화면이 바뀌면 될거 같습니다. */}
                </div>
              </div>

              {/* 컴포넌트 분할 */}
              {mod === "VIEW" ? (
                <Contents
                  setMod={setMod}
                  searchDtParam={props.match.params.searchDt}
                  mdcnType={props.match.params.mdcnType}
                  setMdcnDate={setMdcnDate}
                />
              ) : (
                mod === "MOD" && (
                  <SettingComponent
                    alrmList={alrmList}
                    alrmTypeCd={alrmTypeCd}
                    setAlrmTypeCd={setAlrmTypeCd}
                    resetForm={resetForm}
                    request1118={request1118}
                    setMdcnId={setMdcnId}
                  />
                )
              )}
              {/* 컴포넌트 분할 */}
            </div>
          </div>
        </Container>
        <InputSaveLayer mdcnMemo={mdcnMemo} mdcnDate={mdcnDate} />
        <EveryDayTimeLayer handleDate={handleDate} />
        <WeekTimeLayer handleDate={handleDate} />
        <MonthDateLayer handleDate={handleDate} />
        <ConfirmLayer
          title="알림삭제"
          msg="복약설정을 삭제하겠습니까?"
          handleCancelCB={handleConfirmCancelCB}
          handleConfirmCB={handleConfirmConfirmCB}
        />
        <AlertPopup />
      </Fragment>
    );
  }
};

const History = props => {
  const { userinfo, phonecfg, cfg } = useContext(AppContext);
  const { settingPerionType, resData, takeHist } = props;

  const request1117 = (mdcnDate, mdcnMemo, mdcnType) => {
    PostApi1117(userinfo, cfg, phonecfg, mdcnDate, mdcnMemo, mdcnType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          // openAlertPopup("성공");
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const saveMemo = (mdcnMemo, mdcnDate) => {
    request1117(mdcnDate, mdcnMemo, "BS");
  };

  useEffect(() => {
    userHabit(phonecfg, "BS140");
    NativeAction(phonecfg, "statusColor", "#7FD2C2");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <div className="doctor-massage-box">
        {resData != "" && parseInt(resData.percent) > 90 ? (
          <Fragment>
            <div className="dot-photo">
              {userinfo.sex === "1" ? (
                <img src={Doctor.male.good} alt="" />
              ) : (
                <img src={Doctor.female.good} alt="" />
              )}
            </div>
            <p>
              ‘{userinfo.userName} 님’ {resData.totalDay}일 동안 복약 달성률은{" "}
              {resData.percent}% 입니다.
              <br />
              잘하셨습니다!
            </p>
          </Fragment>
        ) : (
          <Fragment>
            <div className="dot-photo">
              {userinfo.sex === "1" ? (
                <img src={Doctor.male.bad} alt="" />
              ) : (
                <img src={Doctor.female.bad} alt="" />
              )}
            </div>
            <p>
              ‘{userinfo.userName} 님’ {resData.totalDay}일 동안 복약 달성률은{" "}
              {resData.percent}% 입니다.
            </p>
          </Fragment>
        )}
      </div>

      <div className="time-schedule-list">
        {/* {takeHist != "" &&
          takeHist.map((m, i) => <TimeBox m={m} index={i} key={i} />)} */}

        {takeHist != "" && <MemoList memoData={takeHist} saveMemo={saveMemo} />}
      </div>
    </Fragment>
  );
};

const TimeBox = memo(props => {
  const { m, index } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const request1117 = (mdcnDate, mdcnMemo, mdcnType) => {
    PostApi1117(userinfo, cfg, phonecfg, mdcnDate, mdcnMemo, mdcnType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          // openAlertPopup("성공");
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const saveMemo = e => {
    let mdcnDate = m.dt.substr(0, 10);
    let mdcnMemo = $(e.target)
      .closest(".inthe-box")
      .find(".memoTextArea")
      .val();
    request1117(mdcnDate, mdcnMemo, "BS");
  };

  return (
    <div>
      <div className="timebox">
        <span className="fir-date">
          <u>{m.yyyy}</u>
          {m.mmdd}
        </span>
      </div>
      <div className="infobox">
        <a className="btn-memodown">
          <u className="per">{m.percent}%</u>
          <div className="day">
            {m.mdcnCyclDtlNm.split(",").map((n, i) => (
              <MdcnCyclSpan
                mdcnCyclDtlNm={n}
                mdcnYn={m.mdcnYn.split(",")[i]}
                key={i}
              />
            ))}
          </div>
        </a>

        <div className="inthe-box memo">
          <div className="memo-box">
            <textarea className="memoTextArea" defaultValue={m.mdcnMemo} />
          </div>
          <div className="save-area">
            <a onClick={saveMemo} className="btn-savecircle">
              <i></i>저장
            </a>
          </div>
        </div>
      </div>
    </div>
  );
});

const MdcnCyclSpan = memo(props => {
  const { mdcnCyclDtlNm, mdcnYn } = props;

  return <span className={mdcnYn != "" ? "off" : ""}>{mdcnCyclDtlNm}</span>;
});

const Bottom = () => {
  return (
    <div className="under-fix-btnarea">
      <Link to="/sm/medicine/input" className="btn-inputok">
        <i></i>입력
      </Link>
    </div>
  );
};

const Nothing = props => {
  return (
    <div className="sub-contents">
      <div className="nothing-box">
        <div>
          <img src={IC.empty.medicine} alt="" />
          <p>
            입력하신 정보가 없습니다.
            <br />
            복약정보를 입력해 주세요.
          </p>
        </div>
      </div>
    </div>
  );
};

const InputSaveLayer = props => {
  const { mdcnMemo, mdcnDate } = props;

  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const request1117 = (mdcnDate, mdcnMemo, mdcnType) => {
    PostApi1117(userinfo, cfg, phonecfg, mdcnDate, mdcnMemo, mdcnType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          // openAlertPopup("성공");
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const saveMdcnMemo = () => {
    request1117(mdcnDate, mdcnMemo, "BS");
  };

  return (
    <div className="blacklayer-container save-question-layer ">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical">
            <div className="blgr-title">저장</div>

            <div className="save-question-box">
              복용한 약을 저장 하겠습니까?
            </div>

            <div className="tbns-area">
              <a href={void 0} className="btn-round gray">
                취소
              </a>
              <a onClick={saveMdcnMemo} className="btn-round wht">
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
